
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import aiCredentialsAPI from '../../api/captain/aiCredentials';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getAiCredentials($state) {
    return $state.records;
  },
  getAiCredentialByProvider: ($state) => (provider) =>
    $state.records.find((r) => r.provider === provider),
  uiFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, { accountId }) => {
    commit(types.SET_AI_CREDENTIALS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await aiCredentialsAPI.get(accountId);
      commit(types.SET_AI_CREDENTIALS, data);
    } finally {
      commit(types.SET_AI_CREDENTIALS_UI_FLAG, { isFetching: false });
    }
  },

  save: async ({ commit }, { accountId, provider, apiKey, apiBase }) => {
    commit(types.SET_AI_CREDENTIALS_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await aiCredentialsAPI.save(accountId, {
        provider,
        api_key: apiKey,
        api_base: apiBase,
      });
      commit(types.UPDATE_AI_CREDENTIAL, data);
      return data;
    } finally {
      commit(types.SET_AI_CREDENTIALS_UI_FLAG, { isUpdating: false });
    }
  },

  remove: async ({ commit }, { accountId, provider }) => {
    commit(types.SET_AI_CREDENTIALS_UI_FLAG, { isUpdating: true });
    try {
      await aiCredentialsAPI.remove(accountId, provider);
      commit(types.REMOVE_AI_CREDENTIAL, provider);
    } finally {
      commit(types.SET_AI_CREDENTIALS_UI_FLAG, { isUpdating: false });
    }
  },

  getOauthUrl: async (_, { accountId, provider }) => {
    const { data } = await aiCredentialsAPI.getOauthUrl(accountId, provider);
    return data.oauth_url;
  },
};

export const mutations = {
  [types.SET_AI_CREDENTIALS_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_AI_CREDENTIALS]($state, records) {
    $state.records = records;
  },
  [types.UPDATE_AI_CREDENTIAL]($state, record) {
    const idx = $state.records.findIndex((r) => r.provider === record.provider);
    if (idx !== -1) {
      $state.records[idx] = record;
    } else {
      $state.records.push(record);
    }
  },
  [types.REMOVE_AI_CREDENTIAL]($state, provider) {
    const idx = $state.records.findIndex((r) => r.provider === provider);
    if (idx !== -1) {
      $state.records[idx] = { ...$state.records[idx], connected: false, api_key_hint: null, oauth_connected: false };
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
